module.exports = __webpack_public_path__ + "static/media/Landing.54f820a2.svg";